import Web3 from "web3";
import config from "../configure/config";
import { rpcUrls } from "../stores/store";

export const getTokenDecimals = async (tokenAddress, themeType) => {
  const rpcUrl = rpcUrls[themeType][0];

  const web3 = new Web3(rpcUrl);

  let tokenDecimals = 18;

  try {
    const tokenContract = new web3.eth.Contract(
      config["base"].ERC20Abi,
      tokenAddress
    );

    tokenDecimals = await tokenContract.methods.decimals().call();
  } catch (e) {
    tokenDecimals = 18;
  }

  return Number(tokenDecimals);
};
